import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from "../../../../../../services/etiquetado.service";
import { Subject } from "rxjs";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-mepd-new-edit',
    templateUrl: './new-edit.component.html'
})
export class MepdNewEditComponent implements OnInit {

    private _etiquetadorMarcaPaisDenominacion;
    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public _toDelete: any;
    public _editable: boolean;

    public grupoEtiquetaIdCaja;
    public grupoEtiquetaIdPallet;

    private _paisId;
    private _denominacionId;
    private _marcaId;
    private _etiquetadorId;

    public deleteModal = false;

    public randomId = Math.random();

    public disabledMarca: Subject<boolean> = new Subject();
    public disabledCaja: Subject<boolean> = new Subject();
    public disabledPallet: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledMarca.next(true);
                this.disabledCaja.next(false);
                this.disabledPallet.next(false);
            } else {
                this.newEditForm.disable();
                this.newEditForm.patchValue(this.etiquetador);
                this.newEditForm.get('marca').patchValue(this.marcas.find(x => x.id === this.etiquetador.marcaId));
                this.disabledMarca.next(true);
                this.disabledCaja.next(true);
                this.disabledPallet.next(true);
                this.newEditForm.get('grupoEtiquetasCaja')
                    .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === 0));
                this.newEditForm.get('grupoEtiquetasPallet')
                    .patchValue(this.allGrupoEtiquetasPallet[0]);

                if (this.grupoEtiquetasCaja) {
                    for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                        if (grupoEtiquetaCaja.grupoEtiquetaId) {
                            this.newEditForm.get('grupoEtiquetasCaja')
                                .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                            this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                        }
                    }
                }
                if (this.grupoEtiquetasPallet) {
                    for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                        if (grupoEtiquetaPallet.grupoEtiquetaId) {
                            this.newEditForm.get('grupoEtiquetasPallet')
                                .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                            this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                        }
                    }
                }
            }
        }
    }

    @Input() allGrupoEtiquetasCaja;
    @Input() allGrupoEtiquetasPallet;
    @Input() etiquetador?;
    @Input() paisId;
    @Input() denominacionId;
    @Input() etiquetadorId;
    @Input() grupoEtiquetasCaja;
    @Input() grupoEtiquetasPallet;
    @Input() marcas;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            marca: [{ value: '', disabled: !this.editable}, Validators.required],
            grupoEtiquetasCaja: [{ value: '', disabled: !this.editable }, Validators.required],
            grupoEtiquetasPallet: [{ value: '', disabled: !this.editable }, Validators.required],
            impresionAutorizada: [{ value: true, disabled: !this.editable }, Validators.required],
            reimpresionAutorizada: [{ value: true, disabled: !this.editable }, Validators.required]
        });

        if (this.etiquetador) {
            this.newEditForm.patchValue(this.etiquetador);
            this.newEditForm.get('marca').patchValue(this.marcas.find(x => x.id === this.etiquetador.marcaId));
            this.newEditForm.disable();
            this.disabledCaja.next(true);
            this.disabledMarca.next(true);
            this.disabledPallet.next(true);
        } else {
            if (this.marcas) {
                this.disabledMarca.next(false);
            } else {
                this.marcas = [];
                this.marcas.push({des: 'No se encuentra ninguna marca para asociar'});
                this.newEditForm.get('marca').patchValue(this.marcas[0]);
            }
        }

        if (this.grupoEtiquetasCaja) {
            this.newEditForm.get('grupoEtiquetasCaja')
                .patchValue(this.allGrupoEtiquetasCaja[0]);
            for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                if (grupoEtiquetaCaja.grupoEtiquetaId) {
                    this.newEditForm.get('grupoEtiquetasCaja')
                        .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                    this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                }
            }
        } else {
            this.newEditForm.get('grupoEtiquetasCaja')
                .patchValue(this.allGrupoEtiquetasCaja[0]);
        }

        if (this.grupoEtiquetasPallet) {
            this.newEditForm.get('grupoEtiquetasPallet')
                .patchValue(this.allGrupoEtiquetasPallet[0]);
            for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                if (grupoEtiquetaPallet.grupoEtiquetaId) {
                    this.newEditForm.get('grupoEtiquetasPallet')
                        .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                    this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                }
            }
        } else {
            this.newEditForm.get('grupoEtiquetasPallet')
                .patchValue(this.allGrupoEtiquetasPallet[0]);
        }
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.etiquetador) {
            this._etiquetadorMarcaPaisDenominacion = {
                etiquetadorId: this.etiquetadorId,
                marcaId: this.newEditForm.get('marca').value.id,
                paisId: this.paisId,
                denominacionId: this.denominacionId,
                impresionAutorizada: this.newEditForm.get('impresionAutorizada').value ?
                    this.newEditForm.get('impresionAutorizada').value : false,
                reimpresionAutorizada: this.newEditForm.get('reimpresionAutorizada').value ?
                this.newEditForm.get('reimpresionAutorizada').value : false,
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.createEtiquetadorMarcaPaisDenominacion(this._etiquetadorMarcaPaisDenominacion).toPromise().finally(() => {
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    if (this.role === "Administrador") {
                        const promises: Promise<any>[] = [];
                        promises.push(
                            this.updateGrupoEtiquetasCaja()
                        );
                        promises.push(
                            this.updateGrupoEtiquetasPallet()
                        );
                        Promise.all(promises).then(
                            () => {
                                this.refresh.emit(true);
                                this.newEditForm.disable();
                                this.disabledCaja.next(true);
                                this.disabledPallet.next(true);
                                this.disabledMarca.next(true);
                                this.pushMessage.emit('global.success.itemCreated');
                                return true;
                            }, (error) => {
                                this.pushMessage.emit('global.error.noResponse');
                                console.log('Promise rejected with ' + JSON.stringify(error));
                            }
                        ).catch(e => console.log(e));
                    } else {
                        this.refresh.emit(true);
                        this.newEditForm.disable();
                        this.disabledCaja.next(true);
                        this.disabledPallet.next(true);
                        this.disabledMarca.next(true);
                        this.pushMessage.emit('global.success.itemCreated');
                    }
                }
            },
            (error) => {
                this._spinnerService.hideSpinner();
                let mensaje;
                this.showError = true;
                if (error.status === 420) {
                    switch (error.error.ApiErrorCode) {
                        case 6062:
                        mensaje = this._translate.instant('ApiErrors.MEPDYaExiste');
                        break;
                        default:
                        mensaje = this._translate.instant('ApiErrors.serverError');
                        break;
                    }
                } else {
                mensaje = this._translate.instant('ApiErrors.serverError');
                }
                this.mensajes.push({ class: 'error', message: mensaje });
            });
        } else if (this.newEditForm.valid && this.etiquetador) {
            this._etiquetadorMarcaPaisDenominacion = {
                etiquetadorId: this.etiquetadorId,
                marcaId: this.etiquetador.marcaId,
                paisId: this.paisId,
                denominacionId: this.denominacionId,
                impresionAutorizada: this.newEditForm.get('impresionAutorizada').value ?
                    this.newEditForm.get('impresionAutorizada').value : false,
                reimpresionAutorizada: this.newEditForm.get('reimpresionAutorizada').value ?
                this.newEditForm.get('reimpresionAutorizada').value : false,
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.updateEtiquetadorMarcaPaisDenominacion(this._etiquetadorMarcaPaisDenominacion).toPromise().finally(() => {
            }).then(
                (resp) => {
                    if (this.role === "Administrador") {
                        const promises: Promise<any>[] = [];
                        promises.push(
                            this.updateGrupoEtiquetasCaja()
                        );
                        promises.push(
                            this.updateGrupoEtiquetasPallet()
                        );
                        Promise.all(promises).then(
                            () => {
                                this.refresh.emit(true);
                                this.newEditForm.disable();
                                this.disabledCaja.next(true);
                                this.disabledPallet.next(true);
                                this.disabledMarca.next(true);
                                this.pushMessage.emit('global.success.itemUpdated');
                                return true;
                            }, (error) => {
                                this.pushMessage.emit('global.error.noResponse');
                                console.log('Promise rejected with ' + JSON.stringify(error));
                            }
                        ).catch(e => console.log(e));
                    } else {
                        this.refresh.emit(true);
                        this.newEditForm.disable();
                        this.disabledCaja.next(true);
                        this.disabledPallet.next(true);
                        this.disabledMarca.next(true);
                        this.pushMessage.emit('global.success.itemUpdated');
                    }
                },
            );
        }
    }

    public updateGrupoEtiquetasCaja(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasCaja').value.id !== 0) {
                const updateGrupoEtiquetaCaja = {
                    etiquetadorId: this.etiquetadorId,
                    marcaId: resp ? resp.marcaId : this.etiquetador.marcaId,
                    paisId: resp ? resp.paisId : this.etiquetador.paisId,
                    denominacionId: resp ? resp.denominacionId : this.etiquetador.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasCaja').value.id
                };
                this._etiquetadoService.updateGruposEtiquetaEtiquetadorMarcaPaisDenominacion(updateGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasCaja').value.id === 0 && this.grupoEtiquetaIdCaja) {
                const deleteGrupoEtiquetaCaja = {
                    etiquetadorId: this.etiquetadorId,
                    marcaId: resp ? resp.marcaId : this.etiquetador.marcaId,
                    paisId: resp ? resp.paisId : this.etiquetador.paisId,
                    denominacionId: resp ? resp.denominacionId : this.etiquetador.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdCaja
                };
                this._etiquetadoService.deleteGruposEtiquetaEtiquetadorMarcaPaisDenominacion(deleteGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public updateGrupoEtiquetasPallet(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasPallet').value.id !== 0) {
                const updateGrupoEtiquetaPallet = {
                    etiquetadorId: this.etiquetadorId,
                    marcaId: resp ? resp.marcaId : this.etiquetador.marcaId,
                    paisId: resp ? resp.paisId : this.etiquetador.paisId,
                    denominacionId: resp ? resp.denominacionId : this.etiquetador.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasPallet').value.id
                };
                this._etiquetadoService.updateGruposEtiquetaEtiquetadorMarcaPaisDenominacion(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasPallet').value.id === 0 && this.grupoEtiquetaIdPallet) {
                const deleteGrupoEtiquetaPallet = {
                    etiquetadorId: this.etiquetadorId,
                    marcaId: resp ? resp.marcaId : this.etiquetador.marcaId,
                    paisId: resp ? resp.paisId : this.etiquetador.paisId,
                    denominacionId: resp ? resp.denominacionId : this.etiquetador.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdPallet
                };
                this._etiquetadoService.deleteGruposEtiquetaEtiquetadorMarcaPaisDenominacion(deleteGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public cancel() {
        this.newEditForm.reset();
        this.editableChanged.emit(false);
    }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    public edit(etiquetador) {
        this.newEditForm.enable();
        this.disabledMarca.next(true);
        this.disabledCaja.next(false);
        this.disabledPallet.next(false);
        this.editableChanged.emit(etiquetador);
    }

    public askDelete(etiquetador) {
        this._marcaId = etiquetador.marcaId;
        this._paisId = etiquetador.paisId;
        this._etiquetadorId = etiquetador.etiquetadorId;
        this._denominacionId = etiquetador.denominacionId;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteEtiquetadorMarcaPaisDenominacion(this._etiquetadorId,
            this._marcaId, this._paisId, this._denominacionId).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(() => {
                this.closeModal();
                this.refresh.emit(true);
                this.pushMessage.emit('global.success.itemDeleted');
            });

    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }
}